import { Field } from "src/matrixTableNode/MatrixTableNodeEditor";

export const Fallback = ({
  errorMessage,
  readOnly,
}: {
  errorMessage: string | undefined;
  readOnly: boolean;
}) => {
  return (
    <div className="mb-4 flex">
      <div className="flex h-8 w-28 items-center bg-gray-50">
        <p className="pl-1 text-gray-500 font-inter-medium-11px">is any</p>
      </div>
      <div className="flex-1">
        <Field
          errorMessage={errorMessage}
          name="fallback.value"
          readOnly={readOnly}
          variant="cell-expandable"
          result
        />
      </div>
    </div>
  );
};
